import firebase  from "./firebase-config"

export const googleProvider= new firebase.auth.GoogleAuthProvider();
export const facebookProvider =new firebase.auth.FacebookAuthProvider()